import $ from "jquery";

function setupCheckToInclude() {
    $('[data-check-to-include="true"]').each(function () {
        var valueSelector = "#" + this.id.replace("_Include", "_Value");

        $(this).on('change', function() {
            $(valueSelector).attr("readonly", !$(this).is(":checked"));
        });
    });
};

export default setupCheckToInclude;